import AdminDashboard from "../components/AdminDashboard"

export default {
  components: {
    AdminDashboard
  },
  data: () => ({
  }),
  // router: router
}
